export default "__VITE_ASSET__6d473938__"